import React from "react";
import {
  Button, Divider,
  ButtonGroup, Content, Dialog, DialogContainer, Flex, Heading, TextField, View
} from "@adobe/react-spectrum";

class CreateProfileModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      name: '',
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen || this.props.isOpen !== this.state.isOpen) {
      this.setState({isOpen: this.props.isOpen});
    }

    // Reset form when closing
    if (prevProps.isOpen && !this.props.isOpen) {
      this.setState({name: ''});
    }
  }

  onOpenChange = (isOpen) => {
    this.setState({isOpen});
    if (!isOpen) {
      const {onClose} = this.props;
      if (onClose) {
        onClose();
      }
    }
  };

  handleNameChange(value) {
    this.setState({name: value});
  }

  save() {
    const {name} = this.state;
    const {onSave} = this.props;

    if (onSave) {
      onSave({name});
    }
  }

  render() {
    const {isOpen, name} = this.state;
    const {translate} = this.props;

    return (
      <DialogContainer isDismissable={false} onDismiss={() => this.onOpenChange(false)}>
        {isOpen && (
          <Dialog>
            <Heading>{translate('smart_flag_create_profile')}</Heading>
            <Content>
              <TextField
                label={translate('profile_name')}
                value={name}
                onChange={(v) => this.handleNameChange(v)}
                isRequired
                autoFocus
                marginTop="size-200"
                width="size-5000"
              />
            </Content>
            <ButtonGroup>
              <Button variant="secondary" onPress={() => this.onOpenChange(false)}>
                {translate('general_cancel')}
              </Button>
              <Button variant="accent" onPress={() => this.save()} isDisabled={!name}>
                {translate('smart_flag_create')}
              </Button>
            </ButtonGroup>
          </Dialog>
        )}
      </DialogContainer>
    );
  }
}

export default CreateProfileModal;
